// named export
export const Movies = "AllMovies";

